import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import HomePage from './pages/HomePage';
import FixedCallBar from './components/FixedCallBar';
import './App.css';

const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));
const RefundPolicy = lazy(() => import('./pages/RefundPolicy'));

function RouteFallback() {
  return <div className="dh-route-fallback" aria-busy="true" />;
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
          </Routes>
        </Suspense>
        <FixedCallBar />
      </div>
    </BrowserRouter>
  );
}

export default App;
